import React                                                                                                                        from "react";
import { Line }                                                                                                                     from "react-chartjs-2";
import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement, 
  Title,
  Tooltip,
  ChartData,
  ChartOptions,
} from "chart.js";

// ✅ Register required elements
ChartJS.register(CategoryScale, LinearScale, LineElement, PointElement, Legend, Title, Tooltip);

interface DashLineChartProps {
    data: any;
    title: string;
}

const DashLineChart: React.FC<DashLineChartProps> = (props) => {

    const options: ChartOptions<"line"> = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: props.data?.datasets && props.data.datasets.length > 1,
            },
            title: {
                display: true,
                text: props.title,
            },
            datalabels: {
              display: false,
          },
        },
    };

    if (!props.data) return null;

    return (
        <>
            {props.data?.datasets?.length> 0 && (<Line data={props.data} options={options} />)}
        </>
    );
};

export default DashLineChart;
